export default function sum(array, field) {
  return array
    .map((data) => +data[field]).reduce((prev, next) => prev + next);
}
